import { useMemo } from 'react';
import { useUserStore } from '@/stores';

export type ChatFontSize = 'xs' | 'sm' | 'base' | 'lg';

export const FONT_SIZE_OPTIONS: { value: ChatFontSize; label: string; size: string }[] = [
  { value: 'xs', label: 'Extra Small', size: '12px' },
  { value: 'sm', label: 'Small', size: '14px' },
  { value: 'base', label: 'Medium', size: '16px' },
  { value: 'lg', label: 'Large', size: '18px' },
];

export function useChatFontSize() {
  const chatFontSize = useUserStore(state =>
    (state.userSettings.chatFontSize as ChatFontSize) || 'sm'
  );
  const updateUserSettings = useUserStore(state => state.updateUserSettings);

  const setChatFontSize = (value: ChatFontSize) => {
    updateUserSettings('chatFontSize', value);
  };

  // Memoize the font size style to prevent re-renders
  const fontSizeStyle = useMemo((): React.CSSProperties => {
    const option = FONT_SIZE_OPTIONS.find(o => o.value === chatFontSize);
    return { fontSize: option?.size || '14px' };
  }, [chatFontSize]);

  const getFontSizeStyle = (): React.CSSProperties => {
    return fontSizeStyle;
  };

  return { chatFontSize, setChatFontSize, getFontSizeStyle, fontSizeStyle };
}
